// Dependencies
import styled from 'styled-components';

const BlogAuthorSocialStyles = styled.nav`
  margin: 1rem 0 0;

  ul {
    display: flex;
    margin: 0 0 0 -0.25rem;
    padding: 0;
    list-style: none;

    li {
      margin-right: ${(props) => (props?.compact ? '0.25rem' : '1rem')};
      line-height: 1;

      a {
        padding: 0.25rem;
        line-height: 1;
        color: var(--color-bark);
        vertical-align: middle;
        transition: color 0.4s;

        .icon {
          width: 1.2rem;
          transition: fill 0.4s;

          &.british-psychological-society {
            width: 8rem;

            img {
              width: 8rem;
            }
          }
        }

        &:hover,
        &:focus {
          color: var(--color-charcoal);

          .icon {
            fill: var(--color-charcoal);
          }
        }
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

export default BlogAuthorSocialStyles;
